// Real ASYA brand + product assets (client-provided) and derived crops
export const ASSETS = {
  logoWhite: "/brand/asya-logo-white.svg",
  founder:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_asya-hero/artifacts/oeq913t4_YOANNA.jpg",
  // Dark full-bleed hero composite (products on aubergine + circuit texture)
  heroDark:
    "https://static.prod-images.emergentagent.com/jobs/e6eea051-42ed-4614-ab19-55d5f7e4d694/images/ea6eefdf40c4c1b0307d264f57d994b55c8744e9f0c3da8ba99aa5fcbcc40ba1.jpeg",
  // Clean dark product hero (no background texture, products on right)
  heroClean:
    "https://static.prod-images.emergentagent.com/jobs/e6eea051-42ed-4614-ab19-55d5f7e4d694/images/19a886f738db4c3d2654ea6019e5e4c9243a2ccd3a38d43d04eb962a1f4c4ced.jpeg",
  // Centered wide product composite (used stacked under hero text)
  heroCenter:
    "https://static.prod-images.emergentagent.com/jobs/e6eea051-42ed-4614-ab19-55d5f7e4d694/images/98eb08d44cc29f94a792dba490456f91f60e32667200971de38a5b8c5132697a.jpeg",
  // a3 — premium beige family product hero (VIBE + DOSE + GAZE)
  heroProduct:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_asya-hero/artifacts/4guc3hvc_Nano%20Banana%202%20-%20Create%20a%20premium_%20photorealistic%20product%20hero%20image%20for%20a%20CES%202027%20Innovation%20Awards_4.png",
  // a2 — microjet delivery close-up into epidermis cross-section
  microjet:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_asya-hero/artifacts/10ge1i9d_IMAGE%203.jpg",

  // Isolated component crops (from the real product photography)
  components: {
    vibe: "/brand/components/vibe.png",
    dose: "/brand/components/dose.png",
    gaze: "/brand/components/gaze.png",
    phoneAngled: "/brand/components/phone_angled.png",
    serum: "/brand/components/serum.png",
    measureFace: "/brand/components/measure_face.png",
    // Dark-background product cards
    darkVibe: "https://static.prod-images.emergentagent.com/jobs/e6eea051-42ed-4614-ab19-55d5f7e4d694/images/402116527ffb6b98f3b1160ad526a3e441bb7b5db97348063c91c2c46fb135d8.jpeg",
    darkDose: "https://static.prod-images.emergentagent.com/jobs/e6eea051-42ed-4614-ab19-55d5f7e4d694/images/f90762c1ea03ca158f3e6b821d2bd8a5a42e2014afe11bf2c7790de74411e0eb.jpeg",
    darkGaze: "https://static.prod-images.emergentagent.com/jobs/e6eea051-42ed-4614-ab19-55d5f7e4d694/images/12732902bd6f8d35f6163986c49d069d7280f1399688b11d8f46cbb2a2fca6a9.jpeg",
    // How-it-works step imagery (dark, high-res)
    personalizeSerums: "https://static.prod-images.emergentagent.com/jobs/e6eea051-42ed-4614-ab19-55d5f7e4d694/images/bcb73dcd18ac071df8f60e9580f1967650c26d17e12a7b28367ec64b87ec8dc1.jpeg",
    deliverSkin: "https://static.prod-images.emergentagent.com/jobs/e6eea051-42ed-4614-ab19-55d5f7e4d694/images/27c6897558be5d283c7a9ed8c1a7a2e7399e9bb81bdeb591ae56b8388a6678af.jpeg",
  },

  // Before / after skin results
  before:
    "https://static.prod-images.emergentagent.com/jobs/e6eea051-42ed-4614-ab19-55d5f7e4d694/images/645b7300829269cb61453f00acaaeff08b1ac554f55ed6df1d352716ccec0df9.jpeg",
  after:
    "https://static.prod-images.emergentagent.com/jobs/e6eea051-42ed-4614-ab19-55d5f7e4d694/images/64cd6fcfde8c3d9f02968fbfcd676e431978d00e945befebc75ef53473fa6536.jpeg",

  // Web-optimized CES video (from 83MB 4K → faststart H.264)
  video1080: "/media/asya-ces-1080.mp4",
  video720: "/media/asya-ces-720.mp4",
  videoPoster: "/media/asya-poster.jpg",

  // Ambient closed-loop cinematic loop
  loopVideo: "/media/asya-loop.mp4",
  loopPoster: "/media/asya-loop-poster.jpg",
};
